import { IModelDataV3WithUrl, Model } from '@df/catalog/model';

export interface ISearchData extends IModelDataV3WithUrl {}

/**
 * Search model for GA4 purposes
 */
export class Search extends Model<ISearchData> {
    /**
     * Object type id
     * @type {String}
     */
    static override type = 'search';
}
